export const initialState = {
  authEmail: '',
  invalidEmail: false,
}

export const setAuthEmail = (state, payload) => (
  { ...state, authEmail: payload }
)

export const setInvalidEmailStatus = (state, payload) => (
  { ...state, invalidEmail: payload }
)
